"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAETabs = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _FAEContainer = require("../FAEContainer/FAEContainer");

var _FAEText = require("../FAEText/FAEText");

require("./FAETabs.scss");

const _excluded = ["justify", "align", "className", "tabs", "value", "getSelectedTab", "tabWidth"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAETabs = _ref => {
  let {
    justify,
    align,
    className = "",
    tabs = [],
    value = "",
    getSelectedTab = () => {},
    tabWidth = "30%"
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const [selectedTab, setSelectedTab] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    if (value !== "") {
      setSelectedTab(value);
    }
  }, [value]);

  const handleClick = value => {
    getSelectedTab(value);
    setSelectedTab(value);
  };

  return /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--tabs ".concat(className)
  }, _react.Children.toArray(tabs.map(tab => {
    const {
      label,
      value
    } = tab;
    return /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
      className: "fae--tabs-tab-size ".concat(selectedTab === value ? "tabs-active-tab" : ""),
      style: {
        width: tabWidth
      },
      onClick: () => handleClick(value)
    }, label);
  }))));
};

exports.FAETabs = FAETabs;